module.exports = __webpack_public_path__ + "static/media/wifi.7988b760.png";